// extracted by mini-css-extract-plugin
export default {"NutritionFactsImage":"NutritionFactsImage_A1hzq"};